<template>
  <ContactPage />
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContactPage from 'chimera/all/components/page/ContactPage.vue'

export default {
  components: {
    ContactPage,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Kontaktieren Sie uns',
      headDescription:
        'Sie können Maklervergleicher.de kontaktieren, indem Sie das Kontaktformular ausfüllen.',
      path: '/kontakt-aufnehmen',
    }
  },
}
</script>
